import { AnyAction } from 'redux'

export const PAYMENT_SLUG = 'PAYMENT_SLUG'
export const setPaymentSlug = (slug: string) => ({
  type: PAYMENT_SLUG,
  slug,
})
export const paymentSlugReducer = (
  current: string = '',
  action: AnyAction,
): string => {
  switch (action.type) {
    case PAYMENT_SLUG:
      return action.slug
    default:
      return current
  }
}
